export const CHANGE_LOADING_STATE = 'CHANGE_LOADING_STATE';
export const SET_RESPONSE_MESSAGE = 'SET_RESPONSE_MESSAGE';
export const SAVE_FORM_VALUES = 'SAVE_FORM_VALUES';
export const SET_LANGUAGE_VALUES = 'SET_LANGUAGE_VALUES';
export const NEW_LANGUAGE = 'NEW_LANGUAGE';
export const SET_OPENED_NEWS_ITEM_TEXT = 'SET_OPENED_NEWS_ITEM_TEXT';